import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../../includes/Header';
import Footer from '../../includes/Footer';
import Sidebar from '../../includes/Sidebar';
import { Container, Row, Col } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import { postOrder, getFilterList } from '../../apiservices/ApiServices';
import Loader from '../../components/Loader/Loader';
import { FaShieldHalved, FaCodeBranch, FaBox } from "react-icons/fa6";

const MyOrders = () => {
    const [isLoading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [filter, setFilter] = useState([]);
    const [ismsg, setisMsg] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState("");
    const [selectedSortBy, setSelectedSortBy] = useState("");
    const navigate = useNavigate();

    const postOrders = async (postData) => {
        try {
            const res = await getFilterList();
            setFilter(res.data.data);
            try {
                const res = await postOrder();
                setData(res.data.data.records);
                setLoading(false);
            } catch (error) {
                setLoading(false);
                setisMsg(true);
                setData('');
            }

        } catch (error) {
            setLoading(false);
            setisMsg(true);
            setData('');
        }
    };



    useEffect(() => {
        if (!localStorage.getItem('userToken')) {
            navigate("/");
        }
        else {
            postOrders();
        }
    }, [])

    const postupdateOrders = async (postData) => {
        try {
            const res = await postOrder(postData);
            setData(res.data.data.records);
        } catch (error) {
            setData([]);
            setisMsg(true);
        } finally {
            setLoading(false);
        }
    };

    const handleClearFilter = () => {
        setSelectedStatus("");
        setSelectedSortBy("");
        setLoading(true);
        setisMsg(false);
        setData('');
        const postData = {
            status: '',
            sort_by: '',
        };

        postupdateOrders(postData);
    };
    useEffect(() => {
        setLoading(true);

        const postData = {
            status: selectedStatus,
            sort_by: selectedSortBy,
        };

        postupdateOrders(postData);
    }, [selectedStatus, selectedSortBy]);

    const handleDownload = (pdfUrl, orderno) => {
        var link = document.createElement("a");
        link.href = pdfUrl;
        link.setAttribute("download", `${orderno}.pdf`);
        link.click();
        link.remove();
    };

    return (
        <>
            <Header toast={toast} />
            <ToastContainer />
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <div className="crumbsec">
                        <div className="wrap">
                            <Link to={'/'}>Home</Link>
                            <span className="sep">&rsaquo;</span>
                            <Link to={'/profile'}>My Account</Link>
                            <span className="sep">&rsaquo;</span>
                            <span className="cur">My Orders</span>
                        </div>
                    </div>

                    <section className="page-hero cart-hero">
                        <Container>
                            <div className="page-wrap hero-inner">
                                <div className="hero-title">
                                    <span className="hero-icon"><FaBox style={{ color: '#00a99d' }} /></span>
                                    <div>
                                        <h1>My Orders</h1>
                                        <p>Track, view and manage all your orders in one place.</p>
                                    </div>
                                </div>
                                <div className="hero-perks">
                                    <div className="hero-perk"><FaShieldHalved /><span><b>1-Year Warranty</b>on Premium Products</span></div>
                                    <div className="hero-perk"><FaCodeBranch /><span><b>2 Free Replacements</b>on Premium Shield</span></div>
                                    <div className="hero-perk"><FaShieldHalved /><span><b>Secure Checkout</b>100% Safe &amp; Trusted</span></div>
                                </div>
                            </div>
                        </Container>
                    </section>

                    <main className="main" style={{ paddingBottom: '50px' }}>
                        <Container>
                            <div className="layout">
                                <Sidebar />
                                <section className="content">
                                    {ismsg ? (
                                        <div className='nodata'>
                                            <h2>Order is Empty</h2>
                                            <div className='buttonbox'>
                                                <button
                                                    className="btn btn-green mr-2"
                                                    onClick={handleClearFilter}
                                                >
                                                    Clear Filter
                                                </button>
                                                <Link className='btn btn-green' to={'/product'}>Back to shopping</Link>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="tabs-row">
                                                <div className="changedevices">
                                                    <h5>Select Status :</h5>
                                                    <select
                                                        className="custom-select"
                                                        value={selectedStatus}
                                                        onChange={(e) => setSelectedStatus(e.target.value)}
                                                    >
                                                        <option value="">Select Status</option>
                                                        {filter?.order_status?.map((item) => (
                                                            <option key={item.code} value={item.code}>
                                                                {item.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="changedevices">
                                                    <h5>Select Sort By :</h5>
                                                    <select
                                                        className="custom-select"
                                                        value={selectedSortBy}
                                                        onChange={(e) => setSelectedSortBy(e.target.value)}
                                                    >
                                                        <option value="">Select Sort By</option>
                                                        {filter?.sort_by?.map((item) => (
                                                            <option key={item.slug} value={item.slug}>
                                                                {item.title}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="orders">
                                                {data?.map((item) => {
                                                    return (
                                                        <article className="ordercards" key={item?.id}>
                                                            <div className="c-order rdns">
                                                                <div className="oid">Order {item?.order_no}</div>
                                                                <div className="odate">Placed on {item?.order_date}</div>
                                                            </div>
                                                            <div className="c-img">

                                                                <Link to={`/myorders/${item?.order_hash}`}>
                                                                    {item?.details?.is_combo == 1 ?
                                                                        <img src={item?.details?.combo_thumbnail} alt='' title='' />
                                                                        :
                                                                        <img src={item?.details?.media_list[0]?.media_url} alt='' title='' />
                                                                    }
                                                                </Link>
                                                            </div>
                                                            <div className="c-prod">
                                                                <Link to={`/myorders/${item?.order_hash}`}><div className="pname">{item?.details?.name}</div></Link>
                                                                <div className="pmodel">{item?.details?.brands?.name} {item?.details.model?.name}</div>
                                                                <div className="pqty">Qty: {item?.quantity}&nbsp;&nbsp;|&nbsp;&nbsp;₹{item?.price}</div>
                                                                <div className='resdb'>
                                                                    <div className='em1'>
                                                                        <div className="c-order">
                                                                            <div className="oid">Order {item?.order_no}</div>
                                                                            <div className="odate">Placed on {item?.order_date}</div>
                                                                        </div>

                                                                        <div className="c-amt">
                                                                            <div className="alabel">Total Amount</div>
                                                                            <div className="aval">₹{item?.grand_total}</div>
                                                                            <div className="apaid">Paid via {item?.payment_type}</div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='em2'>
                                                                        <div className="c-status">
                                                                            <span
                                                                                className="pill {}"
                                                                                style={{ backgroundColor: item?.status_color_code }}
                                                                            >
                                                                                {item?.status_name}
                                                                            </span>
                                                                            <div className="sinfo">Delivered on May 24, 2025</div>
                                                                        </div>
                                                                        <div className="c-btn">
                                                                            <Link className="btn-detail" to={`/myorders/${item?.order_hash}`}>View Details <svg viewBox="0 0 24 24" fill="none" strokeWidth="2.4"><path d="m9 6 6 6-6 6" /></svg></Link>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="c-amt rdns">
                                                                <div className="alabel">Total Amount</div>
                                                                <div className="aval">₹{item?.grand_total}</div>
                                                                <div className="apaid">Paid via {item?.payment_type}</div>
                                                            </div>
                                                            <div className="c-status rdns">
                                                                <span
                                                                    className="pill {}"
                                                                    style={{ backgroundColor: item?.status_color_code }}
                                                                >
                                                                    {item?.status_name}
                                                                </span>
                                                                <div className="sinfo">Delivered on May 24, 2025</div>
                                                            </div>
                                                            <div className="c-btn rdns">
                                                                <Link className="btn-detail" to={`/myorders/${item?.order_hash}`}>View Details <svg viewBox="0 0 24 24" fill="none" strokeWidth="2.4"><path d="m9 6 6 6-6 6" /></svg></Link>
                                                            </div>
                                                        </article>
                                                    );
                                                })}
                                            </div>
                                        </>
                                    )}
                                </section>
                            </div>
                        </Container>
                    </main>
                </>
            )}

            <Footer toast={toast} />
        </>
    )
}

export default MyOrders;